module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isVisible && _vm.newUi === false) ? _c('div', {
    staticClass: "rounded-md",
    class: _vm.getToastColor()
  }, [_c('div', {
    staticClass: "flex text-white w-full mt-2"
  }, [_c('div', {
    staticClass: "left-0 px-1 py-3 w-11/12 flex items-center"
  }, [_c('img', {
    staticClass: "text-2xl px-3",
    attrs: {
      "src": _vm.toastIcon
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-sm justify-center items-center",
    domProps: {
      "innerHTML": _vm._s(_vm.toastMessage)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex items-start mt-3"
  }, [_c('button', {
    on: {
      "click": _vm.closeToast
    }
  }, [_c('i', {
    staticClass: "fas fa-times text-white"
  })])])]), _vm._v(" "), (_vm.notification.event !== undefined) ? _c('button', {
    staticClass: "ml-12 text-white mt-1 mb-3 hover:underline px-1",
    on: {
      "click": function($event) {
        return _vm.goToRoute()
      }
    }
  }, [_vm._v("\n    Show it\n  ")]) : _vm._e(), _vm._v(" "), (
    _vm.toastLink.course_id &&
    (_vm.toastLink.roundtable_id || _vm.toastLink.live_discussion_id)
  ) ? _c('button', {
    staticClass: "ml-12 text-white mt-1 mb-3 hover:underline px-1",
    on: {
      "click": function($event) {
        return _vm.goToRoundTable()
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.toastLink.follow_up ? 'Create Follow Up' : 'Jump to RoundTable') + "\n  ")]) : _vm._e(), _vm._v(" "), (_vm.myPortfolio.id) ? _c('button', {
    staticClass: "ml-12 text-white mt-1 mb-3 hover:underline px-1",
    on: {
      "click": function($event) {
        return _vm.goToMyPortfolio()
      }
    }
  }, [_vm._v("\n    Go to My Portfolio\n  ")]) : _vm._e(), _vm._v(" "), (_vm.upgrade === true) ? _c('button', {
    staticClass: "ml-12 text-white mt-1 mb-3 hover:underline px-1",
    on: {
      "click": function($event) {
        return _vm.handleUpgrade()
      }
    }
  }, [_vm._v("\n    Upgrade Account\n  ")]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-18eccb79!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/material/components/plToast/plToast.vue
// module id = 2450
// module chunks = 61